// import {
//   Button,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
//   CircularProgress,
// } from '@mui/material';
// import ArrowBackSharpIcon from '@mui/icons-material/ArrowBackSharp';
// import React, { useState, useRef, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import HOST_URL from '../../../utils/Url';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import { useTranslation } from 'react-i18next';
// import { toast } from 'react-toastify';
// import ToastApp from '../../../ToastApp';

// type Props = {};

// const DesignationMasterAdd = (props: Props) => {
//   let navigate = useNavigate();
//   const { t } = useTranslation();
//   const back = useNavigate();

//   const requiredFields = ['designation_name'];
//   const [toaster, setToaster] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const submitTimeoutRef = useRef<NodeJS.Timeout | null>(null);

//   // Enhanced validation schema with comprehensive input validation
//   const validationSchema = Yup.object({
//     designation_name: Yup.string()
//       .test(
//         'required',
//         t('text.reqdesignname'),
//         function (value: any) {
//           return value && value.trim() !== '';
//         }
//       )
//       .max(50, t('text.designationNameMaxLength'))
//       .matches(/^[a-zA-Z0-9\s\-&.,()]+$/, t('text.invalidDesignationName'))
//       .test(
//         'no-special-chars-start-end',
//         t('text.noSpecialCharsStartEnd'),
//         function (value: any) {
//           if (!value) return true;
//           return !/^[^a-zA-Z0-9\s]|[^a-zA-Z0-9\s]$/.test(value);
//         }
//       )
//       .test(
//         'no-multiple-special-chars',
//         t('text.noMultipleSpecialChars'),
//         function (value: any) {
//           if (!value) return true;
//           return !/[\-\s&.,()]{2,}/.test(value);
//         }
//       ),
    
//     short_name: Yup.string()
//       .max(10, t('text.designationShortNameMaxLength'))
//       .matches(/^[a-zA-Z0-9\-]*$/, t('text.invalidDesignationShortName'))
//       .test(
//         'no-special-chars-start-end-short',
//         t('text.noSpecialCharsStartEndShort'),
//         function (value: any) {
//           if (!value) return true;
//           return !/^[^a-zA-Z0-9]|[^a-zA-Z0-9]$/.test(value);
//         }
//       ),
//   });

//   // Function to sanitize input by removing unwanted characters
//   const sanitizeInput = (value: string, fieldName: string) => {
//     if (!value) return value;
    
//     let sanitized = value;
    
//     switch(fieldName) {
//       case 'designation_name':
//         sanitized = value.replace(/[^a-zA-Z0-9\s\-&.,()]/g, '');
//         sanitized = sanitized.replace(/([\-\s&.,()]){2,}/g, '$1');
//         sanitized = sanitized.replace(/^[^a-zA-Z0-9\s]+|[^a-zA-Z0-9\s]+$/g, '');
//         break;
//       case 'short_name':
//         sanitized = value.replace(/[^a-zA-Z0-9\-]/g, '');
//         sanitized = sanitized.replace(/^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g, '');
//         break;
//       default:
//         sanitized = value.replace(/[<>{}[\]\\]/g, '');
//     }
    
//     return sanitized;
//   };

//   // Custom onChange handler to sanitize input in real-time
//   const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
//     const { name, value } = e.target;
//     const sanitizedValue = sanitizeInput(value, name);
    
//     if (value !== sanitizedValue) {
//       formik.setFieldValue(name, sanitizedValue);
//     } else {
//       formik.handleChange(e);
//     }
//   };

//   const formik = useFormik({
//     initialValues: {
//       designation_id: -1,
//       designation_name: "",
//       short_name: "",
//       createdBy: "admin",
//       updatedBy: "admin",
//       createdOn: new Date().toISOString(),
//       updatedOn: new Date().toISOString(),
//     },
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       const sanitizedValues = {
//         ...values,
//         designation_name: sanitizeInput(values.designation_name, 'designation_name'),
//         short_name: sanitizeInput(values.short_name, 'short_name')
//       };
      
//       if (submitTimeoutRef.current) {
//         clearTimeout(submitTimeoutRef.current);
//       }
      
//       if (isSubmitting) {
//         toast.info(t("text.requestInProgress"));
//         return;
//       }
      
//       setIsSubmitting(true);
      
//       try {
//         const response = await axios.post(
//           HOST_URL.HOST_URL2 + `Designation/AddUpdateDesignationmaster`,
//           sanitizedValues
//         );
        
//         if (response.data.isSuccess) {
//           setToaster(false);
//           toast.success(response.data.mesg);
//           navigate("/master/DesignationMaster");
//         } else {
//           setToaster(true);
//           toast.error(response.data.mesg);
//         }
//       } catch (error: any) {
//         if (error.response && error.response.status === 429) {
//           toast.error(t("text.tooManyRequests"));
//         } else {
//           toast.error(t("text.somethingWentWrong"));
//         }
//         setToaster(true);
//       } finally {
//         submitTimeoutRef.current = setTimeout(() => {
//           setIsSubmitting(false);
//         }, 2000);
//       }
//     }
//   });

//   useEffect(() => {
//     return () => {
//       if (submitTimeoutRef.current) {
//         clearTimeout(submitTimeoutRef.current);
//       }
//     };
//   }, []);

//   return (
//     <div>
//       <div
//         style={{
//           padding: "-5px 5px",
//           backgroundColor: "#ffffff",
//           borderRadius: "5px",
//           border: ".5px solid #FF7722",
//           marginTop: "3vh",
//         }}
//       >
//         <CardContent>
//           <Typography
//             variant="h5"
//             textAlign="center"
//             style={{ fontSize: "18px", fontWeight: 500 }}
//           >
//             {t("text.createddesigMAster")}
//           </Typography>

//           <Grid item sm={4} xs={12}>
//             <Typography style={{ marginTop: "-75px" }}>
//               <Button
//                 type="button"
//                 onClick={() => back(-1)}
//                 variant="contained"
//                 style={{
//                   marginBottom: 15,
//                   marginTop: "45px",
//                   backgroundColor: `var(--header-background)`,
//                   width: 20,
//                 }}
//                 disabled={isSubmitting}
//               >
//                 <ArrowBackSharpIcon />
//               </Button>
//             </Typography>
//           </Grid>
//           <Divider />
//           <br />
//           <form onSubmit={formik.handleSubmit}>
//             {toaster === false ? "" : <ToastApp />}
//             <Grid item xs={12} container spacing={2}>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   id="designation_name"
//                   name="designation_name"
//                   label={
//                     <span>
//                       {t("text.enterDesName")}{" "}
//                       {requiredFields.includes("designation_name") && (
//                         <span
//                           style={{
//                             color: formik.values.designation_name
//                               ? "green"
//                               : "red",
//                           }}
//                         >
//                           *
//                         </span>
//                       )}
//                     </span>
//                   }
//                   value={formik.values.designation_name}
//                   placeholder={t("text.enterDesName")}
//                   size="small"
//                   fullWidth
//                   style={{
//                     backgroundColor: "white",
//                     borderColor:
//                       formik.touched.designation_name &&
//                       formik.errors.designation_name
//                         ? "red"
//                         : "initial",
//                   }}
//                   onChange={handleInputChange}
//                   onBlur={formik.handleBlur}
//                   disabled={isSubmitting}
//                   inputProps={{ 
//                     maxLength: 50,
//                     pattern: "[a-zA-Z0-9\\s\\-&.,()]*"
//                   }}
//                   error={formik.touched.designation_name && Boolean(formik.errors.designation_name)}
//                 />
//                 {formik.touched.designation_name &&
//                 formik.errors.designation_name ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.designation_name)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   id="short_name"
//                   name="short_name"
//                   label={t("text.enterDesCode")}
//                   value={formik.values.short_name}
//                   placeholder={t("text.enterDesCode")}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                   onChange={handleInputChange}
//                   onBlur={formik.handleBlur}
//                   disabled={isSubmitting}
//                   inputProps={{ 
//                     maxLength: 10,
//                     pattern: "[a-zA-Z0-9\\-]*"
//                   }}
//                   error={formik.touched.short_name && Boolean(formik.errors.short_name)}
//                 />
//                 {formik.touched.short_name && formik.errors.short_name ? (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.short_name)}
//                   </div>
//                 ) : null}
//               </Grid>

//               <Grid item lg={6} sm={6} xs={12}>
//                 <Grid>
//                   <Button
//                     type="submit"
//                     fullWidth
//                     style={{
//                       backgroundColor: `var(--header-background)`,
//                       color: "white",
//                       marginTop: "10px",
//                     }}
//                     disabled={isSubmitting || !formik.isValid}
//                     startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
//                   >
//                     {isSubmitting ? t("text.submitting") : t("text.save")}
//                   </Button>
//                 </Grid>
//               </Grid>
//               <Grid item lg={6} sm={6} xs={12}>
//                 <Button
//                   type="reset"
//                   fullWidth
//                   style={{
//                     backgroundColor: "#F43F5E",
//                     color: "white",
//                     marginTop: "10px",
//                   }}
//                   onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
//                     formik.resetForm();
//                   }}
//                   disabled={isSubmitting}
//                 >
//                   {t("text.reset")}
//                 </Button>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </div>
//     </div>
//   );
// };

// export default DesignationMasterAdd;


import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  CircularProgress,
} from '@mui/material';
import ArrowBackSharpIcon from '@mui/icons-material/ArrowBackSharp';
import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import HOST_URL from '../../../utils/Url';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import ToastApp from '../../../ToastApp';

type Props = {};

const DesignationMasterAdd = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const back = useNavigate();

  const requiredFields = ['designation_name'];
  const [toaster, setToaster] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Enhanced validation schema with comprehensive input validation
  const validationSchema = Yup.object({
    designation_name: Yup.string()
      .test(
        'required',
        t('text.reqdesignname'),
        function (value: any) {
          return value && value.trim() !== '';
        }
      )
      .max(50, t('text.designationNameMaxLength'))
      .matches(/^[a-zA-Z0-9\s\-&.,()]+$/, t('text.invalidDesignationName'))
      .test(
        'no-special-chars-start-end',
        t('text.noSpecialCharsStartEnd'),
        function (value: any) {
          if (!value) return true;
          return !/^[^a-zA-Z0-9\s]|[^a-zA-Z0-9\s]$/.test(value);
        }
      )
      .test(
        'no-multiple-special-chars',
        t('text.noMultipleSpecialChars'),
        function (value: any) {
          if (!value) return true;
          return !/[\-\s&.,()]{2,}/.test(value);
        }
      ),
    
    short_name: Yup.string()
      .max(10, t('text.designationShortNameMaxLength'))
      .matches(/^[a-zA-Z0-9\-]*$/, t('text.invalidDesignationShortName'))
      .test(
        'no-special-chars-start-end-short',
        t('text.noSpecialCharsStartEndShort'),
        function (value: any) {
          if (!value) return true;
          return !/^[^a-zA-Z0-9]|[^a-zA-Z0-9]$/.test(value);
        }
      ),
  });

  // Function to sanitize input by removing unwanted characters
  const sanitizeInput = (value: string, fieldName: string) => {
    if (!value) return value;
    
    let sanitized = value;
    
    switch(fieldName) {
      case 'designation_name':
        sanitized = value.replace(/[^a-zA-Z0-9\s\-&.,()]/g, '');
        sanitized = sanitized.replace(/([\-\s&.,()]){2,}/g, '$1');
        sanitized = sanitized.replace(/^[^a-zA-Z0-9\s]+|[^a-zA-Z0-9\s]+$/g, '');
        break;
      case 'short_name':
        sanitized = value.replace(/[^a-zA-Z0-9\-]/g, '');
        sanitized = sanitized.replace(/^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g, '');
        break;
      default:
        sanitized = value.replace(/[<>{}[\]\\]/g, '');
    }
    
    return sanitized;
  };

  // Custom onChange handler to sanitize input in real-time
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    const sanitizedValue = sanitizeInput(value, name);
    
    if (value !== sanitizedValue) {
      formik.setFieldValue(name, sanitizedValue);
    } else {
      formik.handleChange(e);
    }
  };

  const formik = useFormik({
    initialValues: {
      designation_id: -1,
      designation_name: "",
      short_name: "",
      createdBy: "admin",
      updatedBy: "admin",
      createdOn: new Date().toISOString(),
      updatedOn: new Date().toISOString(),
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const sanitizedValues = {
        ...values,
        designation_name: sanitizeInput(values.designation_name, 'designation_name'),
        short_name: sanitizeInput(values.short_name, 'short_name')
      };
      
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }
      
      if (isSubmitting) {
        toast.info(t("text.requestInProgress"));
        return;
      }
      
      setIsSubmitting(true);
      
      try {
        const response = await axios.post(
          HOST_URL.HOST_URL2 + `Designation/AddUpdateDesignationmaster`,
          sanitizedValues
        );
        
        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          navigate("/master/DesignationMaster");
        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      } catch (error: any) {
        if (error.response && error.response.status === 429) {
          toast.error(t("text.tooManyRequests"));
        } else {
          toast.error(t("text.somethingWentWrong"));
        }
        setToaster(true);
      } finally {
        submitTimeoutRef.current = setTimeout(() => {
          setIsSubmitting(false);
        }, 2000);
      }
    }
  });

  useEffect(() => {
    return () => {
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "16px", fontWeight: 500, marginLeft: "30px" }}
          >
            {t("text.createddesigMAster")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="button"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
                disabled={isSubmitting}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="designation_name"
                  name="designation_name"
                  label={
                    <span>
                      {t("text.enterDesName")}{" "}
                      {requiredFields.includes("designation_name") && (
                        <span
                          style={{
                            color: formik.values.designation_name
                              ? "green"
                              : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.designation_name}
                  placeholder={t("text.enterDesName")}
                  size="small"
                  fullWidth
                  style={{
                    backgroundColor: "white",
                    borderColor:
                      formik.touched.designation_name &&
                      formik.errors.designation_name
                        ? "red"
                        : "initial",
                  }}
                  onChange={handleInputChange}
                  onBlur={formik.handleBlur}
                  disabled={isSubmitting}
                  inputProps={{ 
                    maxLength: 50,
                    pattern: "[a-zA-Z0-9\\s\\-&.,()]*"
                  }}
                  error={formik.touched.designation_name && Boolean(formik.errors.designation_name)}
                />
                {formik.touched.designation_name &&
                formik.errors.designation_name ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.designation_name)}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  id="short_name"
                  name="short_name"
                  label={t("text.enterDesCode")}
                  value={formik.values.short_name}
                  placeholder={t("text.enterDesCode")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={handleInputChange}
                  onBlur={formik.handleBlur}
                  disabled={isSubmitting}
                  inputProps={{ 
                    maxLength: 10,
                    pattern: "[a-zA-Z0-9\\-]*"
                  }}
                  error={formik.touched.short_name && Boolean(formik.errors.short_name)}
                />
                {formik.touched.short_name && formik.errors.short_name ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.short_name)}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: `var(--header-background)`,
                      color: "white",
                      marginTop: "10px",
                    }}
                    disabled={isSubmitting || !formik.isValid}
                    startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
                  >
                    {isSubmitting ? t("text.submitting") : t("text.save")}
                  </Button>
                </Grid>
              </Grid>
              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                    formik.resetForm();
                  }}
                  disabled={isSubmitting}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default DesignationMasterAdd;